import React, { useEffect } from 'react';
import { Modal } from 'bootstrap';

const EighthPage = () => {
  useEffect(() => {
    // Add click event to all order buttons
    document.querySelectorAll('.btn-buy-combo').forEach(button => {
      button.addEventListener('click', function() {
        // Get the product ID based on button text
        let productId = '';
        if (this.textContent.includes('Mua 1 sản phẩm')) {
          productId = '1';
        } else if (this.textContent.includes('Mua 3 sản phẩm')) {
          productId = '2';
        } else if (this.textContent.includes('Mua 5 tặng 1')) {
          productId = '3';
        }
        
        // Set the product ID in the modal
        const orderModal = document.getElementById('orderModal');
        orderModal.setAttribute('data-product-id', productId);
        
        // Show the modal
        const bsOrderModal = new Modal(orderModal);
        bsOrderModal.show();
      });
    });
  }, []);

  return (
    <div className="page-section" style={{ background: 'linear-gradient(to bottom, #5de0e6, #004aad)', padding: '2rem' }}>
        <div className="container mt-4 combo-container">
            <div className="row" style={{ padding: '0 3rem' }}>
                <div className="col-md-4 text-center mb-5" style={{ fontSize: '2rem',  display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'flex-end' }}>
                    <div>
                        <img src="images/combo1.png" alt="Product" className="img-fluid" style={{ maxWidth: '100px' }} loading="lazy" />
                    </div>
                    <div className="product-info" style={{ minHeight: window.innerWidth >= 992 ? '178px' : 'auto' }}>
                        <div style={{  lineHeight: 1.0, fontSize: '1.5rem' }}>
                            Gói 2 tháng
                        </div>
                        <div style={{ fontSize: '1.8rem', fontWeight: '600', lineHeight: 1.0 }}>
                            6.990.000
                        </div>
                        <button className="btn btn-primary btn-buy-combo" style={{ marginTop: '10px' }}>
                            Mua 1 sản phẩm <i className="fas fa-shopping-cart"></i>
                        </button>
                    </div>
                </div>
                <div className="col-md-4 text-center mb-5" style={{ fontSize: '2rem',  display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'flex-end' }}>
                    <div>
                        <img src="images/combo2.png" alt="Product" className="img-fluid" style={{ maxWidth: '180px' }} loading="lazy" />
                    </div>
                    <div className="product-info">
                        <div style={{ fontSize: '1.8rem', fontWeight: '600', lineHeight: 1.0 }}>
                        6.780.000
                        </div>
                        <div style={{ fontSize: '1.5rem',  lineHeight: 1.0 }}>
                            Gói 6 tháng - <span style={{ fontWeight: '600' }}>Giảm 3%</span>
                        </div>
                        <div style={{ fontSize: '1.5rem',  lineHeight: 1.0 }}>
                            Tiết kiệm <span style={{ fontWeight: '600' }}>630.000</span> <img src="images/freeship.png" alt="Discount" className="img-fluid" style={{ maxWidth: '50px' }} loading="lazy" />
                        </div>
                        <div style={{ fontSize: '1.8rem', fontWeight: '600', lineHeight: 1.0 }}>
                           20.340.000
                        </div>
                        <button className="btn btn-primary btn-buy-combo" style={{ marginTop: '10px' }}>
                            Mua 3 sản phẩm <i className="fas fa-shopping-cart"></i>
                        </button>
                    </div>
                </div>
                <div className="col-md-4 text-center mb-5" style={{ fontSize: '2rem',  display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'flex-end' }}>
                    <div>
                        <img src="images/combo3.png" alt="Product" className="img-fluid" style={{ maxWidth: '300px' }} loading="lazy" />
                    </div>
                    <div className="product-info">
                        <div style={{ fontSize: '1.8rem', fontWeight: '600', lineHeight: 1.0 }}>
                            5.825.000
                        </div>
                        <div style={{ fontSize: '1.5rem',  lineHeight: 1.0 }}>
                            Gói 12 tháng - <span style={{ fontWeight: '600' }}>Tặng 1 NMN</span>
                        </div>
                        <div style={{ fontSize: '1.5rem',  lineHeight: 1.0 }}>
                            Tiết kiệm <span style={{ fontWeight: '600' }}>6.990.000</span> <img src="images/freeship.png" alt="Discount" className="img-fluid" style={{ maxWidth: '50px' }} loading="lazy" />
                        </div>
                        <div style={{ fontSize: '1.8rem', fontWeight: '600', lineHeight: 1.0 }}>
                            34.950.000
                        </div>
                        <button className="btn btn-primary btn-buy-combo" style={{ marginTop: '10px' }}>
                            Mua 5 tặng 1 <i className="fas fa-shopping-cart"></i>
                        </button>
                    </div>
                </div>
            </div>
            <div className="row align-center">
                <div className="col-md-12 text-center end-text" style={{ fontWeight: '600'}}>
                    Chất lượng đẳng cấp cho sức khỏe và tuổi thọ của bạn
                </div>
            </div>
        </div>
        <div className="container-fluid footer">
            <div className="container d-flex justify-content-between align-items-center">
                <a href="tel:0947776292" style={{ textDecoration: 'none' }}>
                    <img src="images/phone.png" alt="Logo" className="footer-logo" loading="lazy" />
                </a>
                <img src="images/logo.jpg" alt="Logo" className="footer-logo" loading="lazy" />
            </div>
        </div>
    </div>
  );
};

export default EighthPage;